// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"415":"1efb9f31","606":"a94b8af7","647":"1fe7d520"}[chunkId] + ".js";
};